import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchUser } from 'redux/settings/actions';

import { Checkbox } from 'semantic-ui-react';

import ProFeaturePlaceholder from 'components/common/ProFeaturePlaceholder';

import './HideAbuseReportCheckbox.css';


const HideAbuseReportCheckbox = ({
  patchUser,
  me,
}) => {
  const { t } = useTranslation();
  const onCheckboxChange = (_e, { checked }) => {
    const form = new FormData();
    form.append('is_abuse_report_removed', checked);
    patchUser(form);
  };

  return (
    <div className="hide-abuse-report-checkbox__component">
      <div className="label">
        {t("Hide (i) icon")}
      </div>
      <ProFeaturePlaceholder
        className="hide-abuse-report-pro-placeholder"
        noKeyIcon
        proLabel
        locked={
          me &&
          me.subscription &&
          !me.subscription.ff_remove_abuse_report
        }
        placeholderContent={
          <div>
            {t("You can hide the (i) Icon from the bottom of " +
               "your HeyLink.me page on the PRO plan.")}
          </div>
        }
      >
        <div className="checkbox-wrapper">
          <div className="option">{t("OFF")}</div>
          <Checkbox
            toggle
            checked={me.is_abuse_report_removed}
            onChange={onCheckboxChange}
            disabled={
              me &&
              me.subscription &&
              !me.subscription.ff_remove_abuse_report
            }
          />
          <div className="option">{t("ON")}</div>
        </div>
      </ProFeaturePlaceholder>
    </div>
  );
};

HideAbuseReportCheckbox.propTypes = {
  patchUser: PropTypes.func.isRequired,
  me: PropTypes.object,
};

HideAbuseReportCheckbox.defaultProps = {
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    patchUser,
  },
)(HideAbuseReportCheckbox);
